(function () {
    'use strict';

    angular.module("imApp").factory("menuGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3486,
                    parameters: parms || {}
                });
            },
            saveObj: function (menu) {
                return $ihttp.post({
                    method: 3487,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
